import React from "react";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";

interface StatsCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon: IconDefinition;
  iconColor?: string;
  bgGradient?: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  subtitle,
  icon,
  iconColor = "#3498db",
  bgGradient = "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  trend,
}) => {
  return (
    <Card
      className="h-100 border-0 shadow-sm"
      style={{
        minHeight: 120,
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
    >
      <Card.Body
        className="p-3 d-flex align-items-center"
        style={{ 
          flex: 1,
          gap: "12px"
        }}
      >
        <div
          className="avatar avatar-lg rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
          style={{
            background: bgGradient,
            width: 40,
            height: 40,
            minWidth: 40,
            minHeight: 40,
          }}
        >
          <FontAwesomeIcon icon={icon} className="text-white" style={{ fontSize: "14px" }} />
        </div>
        <div style={{ flex: 1, minWidth: 0, overflow: "hidden", paddingRight: trend ? "45px" : "0" }}>
          <h6
            className="text-body-tertiary mb-1 fw-medium text-uppercase"
            style={{
              fontSize: "10px",
              letterSpacing: "0.5px",
              lineHeight: "1.2",
            }}
          >
            {title}
          </h6>
          <div 
            className="text-body-emphasis fw-bold mb-0" 
            style={{ 
              fontSize: "18px",
              lineHeight: "1.1",
              wordBreak: "break-word",
            }}
          >
            {value}
          </div>
          {subtitle && (
            <div 
              className="text-body-secondary" 
              style={{ 
                fontSize: "10px",
                lineHeight: "1.1",
                wordBreak: "break-word",
              }}
            >
              {subtitle}
            </div>
          )}
        </div>
        
        {/* Trend em posição absoluta */}
        {trend && (
          <div 
            style={{ 
              position: "absolute",
              top: "8px",
              right: "8px",
              display: "flex",
              alignItems: "center",
              gap: "3px",
              background: "var(--phoenix-body-bg)",
              backdropFilter: "blur(4px)",
              borderRadius: "12px",
              padding: "4px 6px",        
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            }}
          >
            <FontAwesomeIcon
              icon={trend.isPositive ? faArrowUp : faArrowDown}
              style={{ 
                color: trend.isPositive ? "#10b981" : "#ef4444",
                fontSize: "9px"
              }}
            />
            <span
              style={{
                color: trend.isPositive ? "#10b981" : "#ef4444",
                fontWeight: "bold",
                fontSize: "9px"
              }}
            >
              {trend.value}%
            </span>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default StatsCard;
